import { render, staticRenderFns } from "./OwalListRowAccessory.vue?vue&type=template&id=0012d867&scoped=true"
import script from "./OwalListRowAccessory.vue?vue&type=script&lang=js"
export * from "./OwalListRowAccessory.vue?vue&type=script&lang=js"
import style0 from "./OwalListRowAccessory.vue?vue&type=style&index=0&id=0012d867&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0012d867",
  null
  
)

export default component.exports